import React, { useState, useEffect, useRef } from 'react';
import { Button, Image, Input, InputNumber, Progress, List, Upload, Form, message, Modal, Select, Tooltip, Table, Typography } from 'antd';
import { WarningOutlined, ZoomInOutlined, ExclamationCircleOutlined, PlayCircleOutlined, UploadOutlined } from '@ant-design/icons';
import BraftEditor from 'braft-editor';
import 'braft-editor/dist/index.css';

import * as CONST from '../../common/const';
import * as REQUEST from "../../common/request";
import * as Utils from "../../common/utils";

import Page from '../../components/page';
import UploadPictureList from '../../components/uploadPictureList';
import './index.less';

const PageModel = props => {
  const [form] = Form.useForm();
  const [modalFormObj, setModalFormObj] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [content, setContent] = useState('');//游船介绍--富文本


  const closeModalHandle = () => {
    setModalVisible(false);
    setContent('');//游船介绍--富文本
  };

  const [list, setList] = useState([]);
  const getList = async () => {
    const result = await REQUEST.get({
      url: '/zhujiajiao/v2/admin/cruise/list'
    });
    if (!result) return;
    setList(result.data.list);
  };


  useEffect(() => {
    getList();
    return () => false;
  }, [123]);

  const submitHandle = async (params = {}) => {
    if (!params) return;

    let url = '/zhujiajiao/v2/admin/cruise/add';
    if (modalFormObj?.id) {
      params.id = modalFormObj.id;
      url = '/zhujiajiao/v2/admin/cruise/update';
    }
    const result = await REQUEST.post({
      url,
      data: params
    });
    if (!result) return;

    message.success('操作成功');

    closeModalHandle();
    getList();
  };
  const deleteHandle = async (id) => {
    if (!id) return;

    const result = await REQUEST.post({
      url: '/zhujiajiao/v2/admin/cruise/delete',
      data: {
        id
      }
    });
    if (!result) return;
    message.success('操作成功');
    getList();
  };

  return (
    <Page {...{
      ...props,
      breadcrumbs: [{ label: '首页' }, { label: '游船信息介绍' }],
      title: '游船信息介绍'
    }}>
      <section className="intro-container" style={{ minHeight: window.innerHeight }}>
        <div className="intro-top">
          <Button type="primary" onClick={async () => {
            setModalVisible(true);
            form.resetFields();
          }}>新增</Button>
        </div>
        <Table {...{
          size: 'small',
          locale: { emptyText: '暂无数据' },
          dataSource: list,
          columns: [
            {
              title: '标题', dataIndex: 'title', key: 'title', width: 100,
              render: (text) => <Tooltip placement="topLeft" title={text}>{text}</Tooltip>
            },
            {
              title: '操作', dataIndex: 'edit', key: 'edit', width: 156, fixed: 'right',
              render: (text, record, index) => {
                const _style = { marginRight: 10, fontSize: 12 };
                return <>
                  <Button size="small" type="primary" ghost style={_style} onClick={() => {
                    const _record = { ...record };
                    setModalFormObj(_record);
                    if (_record.content) {
                      const detailValue = BraftEditor.createEditorState(_record.content);
                      setContent(detailValue)
                    }
                    form.setFieldsValue({ ...record });
                    setModalVisible(true);
                  }}>编辑</Button>
                  <Button type="text" danger size="small" style={_style} onClick={() => {
                    Modal.confirm({
                      title: '删除的数据将无法找回，请慎重操作！',
                      icon: <WarningOutlined style={{ color: '#E45357' }} />,
                      // content: 'Bla bla ...',
                      okText: '确认删除',
                      cancelText: '取消',
                      onOk: () => {
                        deleteHandle(record.id);
                      },
                      onCancel: () => {
                        // console.log('Cancel');
                      },
                    });
                  }}>删除</Button>
                </>
              }
            },
          ]
        }} />
      </section>

      <Modal {...{
        title: modalFormObj && '编辑' || '新增',
        width: '75%',
        open: modalVisible,
        maskClosable: false,
        destroyOnClose: true,
        onCancel: closeModalHandle,
        footer: null
      }}>
        {
          modalVisible && <Form {...{
            initialValues: modalFormObj || undefined,
            form,
            labelCol: { span: 6 },
            wrapperCol: { span: 16 },
            onFinish: values => {
              if (content && content.toHTML() != '<p></p>') {
                values.content = content.toHTML();
              }
              console.log(values);
              submitHandle(values);
            }
          }}>

            <Form.Item label="游船信息标题" name="title" rules={[
              { required: true, message: '游船信息标题不能为空' }]}>
              <Input placeholder="游船信息标题" allowClear />
            </Form.Item>

            {/* -------------------------------------------------------------------------------- */}

            <Form.Item label="游船信息">
              <BraftEditor
                style={{ height: 'calc(100% - 52px)', overflow: 'auto' }}
                value={content}
                onChange={setContent}
                media={{
                  uploadFn: Utils.editorUploadHelper({ url: '/zhujiajiao/v2/admin/cruise/upload' }),
                  validateFn: (file) => {
                    return Utils.imageUploadSizeVerify(file);
                  }
                }}
                imageControls={[
                  'float-left', // 设置图片左浮动
                  'float-right', // 设置图片右浮动
                  'align-left', // 设置图片居左
                  'align-center', // 设置图片居中
                  'align-right', // 设置图片居右
                  'link', // 设置图片超链接
                  'size', // 设置图片尺寸
                  'remove' // 删除图片
                ]}
              />
            </Form.Item>

            {/* -------------------------------------------------------------------------------- */}
            <Form.Item label=" " colon={false}>
              <Button style={{ marginRight: 16 }} onClick={closeModalHandle}>取消</Button>
              <Button style={{ marginRight: 16 }} type="primary" htmlType="submit">提交</Button>
            </Form.Item>
          </Form>
        }
      </Modal>

    </Page>
  );
};

export default PageModel;
